import { Component, EventEmitter, Output } from '@angular/core';
import { SpeechRecognitionService } from '../../../core/services/speech-recognition.service';


@Component({
  selector: 'app-microphone',
  templateUrl: './microphone.component.html',
  styleUrls: ['./microphone.component.scss']
})
export class MicrophoneComponent {

  voz:string=''
  flag=true;

  @Output() voice = new EventEmitter();


  constructor(
    public speechRecognitionService:  SpeechRecognitionService
  ){
    this.speechRecognitionService.init();
  }

  startRecognition() {
    this.flag=!this.flag;
    this.speechRecognitionService.start();
  }
  stopRecognition() {
    this.flag=!this.flag;
    this.speechRecognitionService.stop();
    this.voz = this.speechRecognitionService.getText();
    if(this.voz.includes("tudo maiúsculo") || this.voz.includes("tudo maiúscula")){
      this.voice.emit(this.voz.toUpperCase());
     }else{
      this.voice.emit(this.voz);
     }

  }

}
